export const PLAYER_COLORS = [
  "#B4532F", // Rust
  "#D9A441", // Gold
  "#4A6FA5", // Slate Blue
  "#6E8B5E", // Forest Green
  "#C77B9E", // Dusty Pink
  "#7B9EA8", // Soft Teal
  "#A85751", // Redwood
  "#8A7A64", // Muted Tan
]

export const SCATTERGORIES_LETTERS = [
  "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "R", "S", "T", "W"
]

const CODE_WORDS = [
  "PLUM", "MANGO", "PEACH", "LEMON", "KIWI", "GRAPE", "APPLE", "BERRY", "MELON", "OLIVE",
  "PECAN", "MAPLE", "CEDAR", "RIVER", "STONE", "CLOUD", "STORM", "FROST", "EMBER", "SPARK",
  "TIGER", "OTTER", "GOOSE", "MOOSE", "BISON", "ROBIN", "FINCH", "GECKO", "KOALA", "LLAMA",
  "ZEBRA", "PANDA", "COMET", "NOVA", "LUNAR", "SOLAR", "DELTA", "ECHO", "TANGO", "RUMBA"
]

export function generateRoomCode(rand = Math.random) {
  const word = CODE_WORDS[Math.floor(rand() * CODE_WORDS.length)]
  const num = 10 + Math.floor(rand() * 90)
  return `${word}-${num}`
}

export function shuffle(array, rand = Math.random) {
  const out = [...array]
  for (let i = out.length - 1; i > 0; i--) {
    const j = Math.floor(rand() * (i + 1))
    ;[out[i], out[j]] = [out[j], out[i]]
  }
  return out
}

export function matchesLetter(answer, letter) {
  if (!answer || !letter) return false
  const clean = answer.trim().toLowerCase()
  const key = letter.toLowerCase()
  if (clean.startsWith(key)) return true
  
  // Check if it starts with an article followed by space
  const articles = ["the ", "a ", "an "]
  for (const article of articles) {
    if (clean.startsWith(article)) {
      const remainder = clean.slice(article.length).trim()
      if (remainder.startsWith(key)) return true
    }
  }
  return false
}

export function computeScores(answers = {}, vetoes = {}, letter = "") {
  const playerIds = Object.keys(answers)
  const scores = {}
  
  // Initialize scores
  playerIds.forEach((pid) => {
    scores[pid] = 0
  })

  // Duplicate detection & breakdown category-by-category (0 to 11)
  const duplicates = Array.from({ length: 12 }, () => ({}))
  const breakdown = Array.from({ length: 12 }, () => ({}))

  for (let cIdx = 0; cIdx < 12; cIdx++) {
    // 1. Gather non-empty standardized answers
    const answersMap = new Map() // stdAnswer -> Array of playerIds
    
    playerIds.forEach((pid) => {
      const pAnswers = answers[pid] || []
      const originalVal = pAnswers[cIdx] || ""
      const cleanVal = originalVal.trim().toLowerCase()
      
      if (cleanVal !== "") {
        if (!answersMap.has(cleanVal)) {
          answersMap.set(cleanVal, [])
        }
        answersMap.get(cleanVal).push(pid)
      }
    })

    // 2. Mark duplicates (if count > 1)
    answersMap.forEach((pids, stdAns) => {
      if (pids.length > 1) {
        pids.forEach((pid) => {
          duplicates[cIdx][pid] = true
        })
      }
    })

    // 3. Tabulate points per player for this category
    playerIds.forEach((pid) => {
      const pAnswers = answers[pid] || []
      const originalVal = pAnswers[cIdx] || ""
      const isDuplicate = !!duplicates[cIdx][pid]
      const isVetoed = !!(vetoes[cIdx]?.[pid])
      const startsWithLetter = matchesLetter(originalVal, letter)
      
      const hasValue = originalVal.trim() !== ""
      const points = hasValue && !isDuplicate && !isVetoed ? 1 : 0
      
      scores[pid] += points

      breakdown[cIdx][pid] = {
        answer: originalVal,
        isDuplicate,
        isVetoed,
        startsWithLetter,
        points
      }
    })
  }

  return { scores, duplicates, breakdown }
}
